import React from 'react'

import { StyledSpinner } from './style'

const Loader = ({ size = '64px', secondaryColor=false }) => {
  return <StyledSpinner secondaryColor={secondaryColor} size={size} data-test="spinner" data-testid="test-spinner" />
}

export default Loader